import { BadRequestError } from '@cian/valuation-utils-component';
import { UnknownError } from '@cian/peperrors/shared';
import type { TMeta } from '@cian/logger/shared';
import type { FetchResponse } from '@cian/http-api';

import { TThunkAction } from '../../types/redux';
import { fetchGetPaymentUrl, TGetPaymentUrlResponse } from '../../repositories/legal-check/v1/get-payment-url';
import { selectId } from '../../selectors/legalCheck';
import { createCallbackUrl } from './utils/createCallbackUrl';

export const getPaymentUrl = (): TThunkAction<Promise<void>> => async (_dispatch, getState, context) => {
  const { httpApi, logger } = context;
  const state = getState();
  const requestId = selectId(state);

  try {
    if (!requestId) {
      throw new UnknownError({
        message: `Unexpected value, requestId is ${requestId}`,
        domain: 'getPaymentUrl.ts',
      });
    }

    const callbackUrl = createCallbackUrl(requestId);

    const res: FetchResponse<TGetPaymentUrlResponse> = await fetchGetPaymentUrl({
      httpApi,
      parameters: {
        callbackUrl,
        requestId,
      },
    });

    if (res.statusCode !== 200) {
      throw new BadRequestError({
        message: res.response?.message || /* istanbul ignore next */ 'Ошибка при получении url на оплату',
        domain: 'getPaymentUrl.ts',
      });
    }

    window.location.href = res.response.url;
  } catch (error) {
    logger.error('Failed get legal-check/v1/get-payment-url/', error as TMeta);

    throw new Error('Что-то пошло не так. Попробуйте еще раз, либо зайдите позже');
  }
};
